export const DeltaIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3.39613 15.9993C3.09057 15.9993 2.86835 15.8674 2.72946 15.6035C2.59057 15.3396 2.60446 15.0827 2.77113 14.8327L9.3753 4.93685C9.52807 4.71463 9.73641 4.60352 10.0003 4.60352C10.2642 4.60352 10.4725 4.71463 10.6253 4.93685L17.2295 14.8327C17.3961 15.0827 17.41 15.3396 17.2711 15.6035C17.1322 15.8674 16.91 15.9993 16.6045 15.9993H3.39613ZM4.79196 14.4993H15.2086L10.0003 6.70768L4.79196 14.4993Z" fill="currentColor" />
    </svg>

  )
}